import Vue from 'vue'
import VueRouter from 'vue-router'
import prodRoutes from './routes'
import devRoutes from './dev-routes'
import store from '$app/store'

Vue.use(VueRouter)

const isDev = process.buildEnv === 'Test' || process.env.NODE_ENV === 'development';

const router = new VueRouter({
  base: window.base,
  mode: 'history',
  routes: isDev ? [...prodRoutes, ...devRoutes] : prodRoutes
})

router.beforeResolve((to, from, next) => {
  store.commit('setLoading', true);
  next()
})
router.afterEach(() => {
  store.commit('setLoading', false);
})

export default router
